import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getTotalPages } from "../../utils/helpers/getTotalPages";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";

const SelectAsyncPaginateDepartamento = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({});
  const { API_URL } = getEnvVariables();
  const getAllDepartments = async () => {
    let allDepartments = [];
    let page = 1;
    let lastPage = 999

    while (page <= lastPage) {
      const response = await fetch(`${API_URL}/utils/departamentos?page=${page}`);
      const responseData = await response.json();
      if (responseData?.results && lastPage === 999) {
        const totalItems = responseData.count
        const itemsPerPage = responseData?.results.length
        lastPage = getTotalPages(totalItems, itemsPerPage)
      }
      allDepartments = allDepartments.concat(responseData.results);
      page++;
    }
    return allDepartments;
  };

  const getDefaultValue = async () => {
    if (!props.departamento) return
    let urlMun = `${API_URL}/utils/municipios/${props.departamento}/`
    let departaments = []

    const response = await fetch(urlMun)
    const responseDep = await response.json()

    departaments = await getAllDepartments()
    const defaultValue = departaments.filter(item => item.id === responseDep.departamento)[0]
    props.onChange(defaultValue)
  }

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/departamentos/?page=${page}`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next
    } else {
      resp = itemsDonwload
    }
    return {
      options: resp.results,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify()}
      value={props.value || getDefaultValue || ""}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      isSearchable
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

export default SelectAsyncPaginateDepartamento;